module.exports = __webpack_public_path__ + "static/media/dean.16ea5d88.png";